<div class="vc-modal__innerContainer i18nChoices__modalContent">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>

  <div class="i18nChoices__modalTitle" i18n="@@I18N_MODAL.TITLE">Choose your preferences</div>
  <div *ngIf="hasWallet" class="i18nChoices__walletMsg">
    <p i18n="@@I18N_MODAL.WALLET_MSG">
      Please note: to continue to use your VC wallet, you must select
      <a
        i18n-href="@@I18N_MODAL.WALLET_MSG.URL"
        href="https://faq.vestiairecollective.com/hc/en-us/articles/200619652--Discover-the-wallet"
      >
        SEPA-Euro
      </a>
      parameters.
    </p>
  </div>

  <div class="i18nChoices__gridContainer">
    <div class="i18nChoices__modalCol">
      <label class="vc__label">{{ (countries$ | async)?.title }}</label>

      <div class="vc__select">
        <select
          aria-label="countries"
          name="countries"
          class="i18nChoices__select"
          [ngModel]="country"
          (ngModelChange)="selectCountry($event)"
        >
          <option *ngFor="let c of (countries$ | async)?.countriesShortLists; trackBy: trackByFn" [ngValue]="c">{{
            c.name
          }}</option>
          <optgroup label="..."></optgroup>
          <option *ngFor="let c of (countries$ | async)?.countriesFullLists" [ngValue]="c">{{ c.name }}</option>
        </select>
      </div>
    </div>

    <div class="i18nChoices__modalCol">
      <label class="vc__label">{{ (languages$ | async)?.title }}</label>
      <div class="vc__select">
        <select
          aria-label="languages"
          name="languages"
          class="i18nChoices__select"
          [ngModel]="language"
          (ngModelChange)="selectLanguage($event)"
        >
          <option *ngFor="let l of (languages$ | async)?.list; trackBy: trackByFn" [ngValue]="l">{{ l?.name }}</option>
        </select>
      </div>
    </div>

    <div class="i18nChoices__modalCol">
      <label class="vc__label">{{ (currencies$ | async)?.title }}</label>
      <div class="vc__select">
        <select
          aria-label="currencies"
          name="currencies"
          class="i18nChoices__select"
          [ngModel]="currency"
          (ngModelChange)="selectCurrency($event)"
        >
          <option *ngFor="let c of (currencies$ | async)?.list; trackBy: trackByFn" [ngValue]="c">
            {{ c?.symbol }} <span *ngIf="isoDifferentSymbol(c?.symbol, c?.isoCode)">{{ c?.isoCode }}</span>
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="i18nChoices__modalAction">
    <button
      class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full vc-btn--notfull--md-up"
      (click)="validate()"
      mat-dialog-close
      i18n="@@I18N_MODAL.SAVE_BUTTON"
    >
      Save Changes
    </button>
  </div>
</div>
